import { DATA_TYPE_GROUP_SERVICE_NAME, DataTypeGroupServiceProvider } from './data-type-group.service'

export const DATA_TYPE_GROUP_SERVICES_MODULE_NAME = 'simax.services.dataTypeGroup'

const dataTypeGroupServicesModule = angular.module(DATA_TYPE_GROUP_SERVICES_MODULE_NAME, [])

dataTypeGroupServicesModule.provider(DATA_TYPE_GROUP_SERVICE_NAME, DataTypeGroupServiceProvider)
